/* ByMoove - home : compteurs animes du bandeau chiffres (impact).
   Cible [class*="__stats"] .multicolumn-card__title. Repli sur repos si non parsable.
   Respecte prefers-reduced-motion. */
(function () {
  function grp(n) { return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
  function animate(el) {
    if (el.dataset.bmCounted) return;
    var raw = el.textContent.trim();
    var m = raw.match(/^(\D*)(\d[\d\s.,  ]*\d|\d)(.*)$/);
    if (!m) return;
    var prefix = m[1], suffix = m[3];
    var target = parseInt(m[2].replace(/\D/g, ''), 10);
    if (isNaN(target)) return;
    el.dataset.bmCounted = '1';
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = prefix + grp(target) + suffix; return;
    }
    var dur = 1500, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + grp(Math.round(eased * target)) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = prefix + grp(target) + suffix;
    }
    requestAnimationFrame(step);
  }
  function run() {
    var sec = document.querySelector('[class*="__stats"]');
    if (!sec) return;
    var els = sec.querySelectorAll('.multicolumn-card__title');
    if (!els.length) return;
    function fire() { els.forEach(animate); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
      }, { threshold: 0.4 });
      io.observe(sec);
    } else { fire(); }
  }
  /* Produit "prix sur devis" (devis_obligatoire) : bouton Demander un devis
     -> ajoute au panier avec la propriété _devis puis va sur /pages/mon-devis. */
  function wireDevisOblig() {
    var btn = document.getElementById('bymoove-ask-devis');
    if (!btn || btn.dataset.bmWired) return;
    btn.dataset.bmWired = '1';
    btn.addEventListener('click', function () {
      var v = btn.getAttribute('data-variant');
      btn.disabled = true;
      function go() { window.location.href = '/pages/mon-devis'; }
      if (!v) { go(); return; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(v), quantity: 1, properties: { _devis: '1' } }] }) })
        .then(go).catch(go);
    });
  }
  /* Validation des formulaires (recette 16/10 n°29) : format de chaque champ + message d'erreur sous le champ. */
  function bmDigits(v) { return (v || '').replace(/\D/g, ''); }
  function bmRule(el) {
    var n = (el.name || '').toLowerCase(), v = (el.value || '').trim(), t = (el.type || '').toLowerCase();
    if (t === 'hidden' || t === 'submit' || el.disabled || n === 'contact[site_web]') return '';
    if (t === 'checkbox') { return (el.required || el.dataset.bmConsent) && !el.checked ? 'Merci de cocher cette case pour envoyer votre demande.' : ''; }
    if (!v) return el.required ? 'Ce champ est obligatoire.' : '';
    if (t === 'email' || n === 'contact[email]') return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v) ? '' : 'Adresse e-mail invalide (ex. nom@structure.fr).';
    if (t === 'tel' || /t[ée]l[ée]phone|phone/.test(n)) {
      var d = bmDigits(v);
      return (/^[+0-9 ().\-]+$/.test(v) && d.length >= 9 && d.length <= 15) ? '' : 'Numéro de téléphone invalide (ex. 06 12 34 56 78).';
    }
    if (/siret/.test(n)) {
      var s = v.replace(/[\s.\-]/g, '');
      if (/n° pro|professionnel|rpps|adeli/.test(n)) return (/^\d+$/.test(s) && [9, 11, 14].indexOf(s.length) > -1) ? '' : 'Numéro invalide : SIRET (14 chiffres), RPPS (11) ou ADELI (9).';
      return (/^\d{14}$/.test(s)) ? '' : 'Le SIRET compte 14 chiffres.';
    }
    if (/surface/.test(n)) return /^\d+([.,]\d+)?\s*(m²|m2)?$/i.test(v) ? '' : 'Indiquez une surface en m² (ex. 120).';
    if (el.required && v.length < 2) return 'Ce champ est trop court.';
    return '';
  }
  function bmCheck(el) {
    var msg = bmRule(el);
    var holder = el.type === 'checkbox' ? (el.closest('label') || el.parentNode) : el;
    var id = (el.id || (el.id = 'bmf-' + Math.random().toString(36).slice(2, 8))) + '-err';
    var err = document.getElementById(id);
    if (msg) {
      if (!err) { err = document.createElement('p'); err.id = id; err.className = 'bm-ferr'; err.setAttribute('role', 'alert'); holder.insertAdjacentElement('afterend', err); }
      err.textContent = msg;
      el.setAttribute('aria-invalid', 'true'); el.setAttribute('aria-describedby', id); el.classList.add('bm-finvalid');
    } else {
      if (err) err.remove();
      el.removeAttribute('aria-invalid'); el.classList.remove('bm-finvalid');
    }
    return !msg;
  }
  window.BMValidate = function (form) {
    var first = null;
    form.querySelectorAll('input, textarea, select').forEach(function (el) { el.dataset.bmTouched = '1'; if (!bmCheck(el) && !first) first = el; });
    if (first) { first.focus({ preventScroll: true }); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); return false; }
    return true;
  };
  (function () {
    if (document.getElementById('bm-ferr-css')) return;
    var st = document.createElement('style'); st.id = 'bm-ferr-css';
    st.textContent = 'p.bm-ferr,.bmda__field>p.bm-ferr{display:block;color:#b3261e!important;font-size:13px!important;line-height:1.4;margin:6px 0 0!important;font-weight:500!important;letter-spacing:0;text-align:left;text-transform:none}' +
      'input.bm-finvalid,textarea.bm-finvalid,select.bm-finvalid{border-color:#d93025!important;background:#fff8f7!important;box-shadow:0 0 0 3px rgba(217,48,37,.12)!important}' +
      'input[type=checkbox].bm-finvalid{outline:2px solid #d93025;outline-offset:2px}';
    document.head.appendChild(st);
  })();
  /* Après envoi : le bloc garde la taille du formulaire, message de succès centré */
  (function () {
    var ok = document.querySelector('.bmda__ok'); if (!ok) return;
    var card = ok.closest('.bmda__card'); if (!card) return;
    var h = 0; try { h = parseInt(sessionStorage.getItem('bmFormH'), 10) || 0; sessionStorage.removeItem('bmFormH'); } catch (e) {}
    if (h) card.style.minHeight = h + 'px';
  })();

  /* Formulaires de contact/devis : consentement RGPD + anti-spam honeypot (global). */
  function hardenContactForms() {
    var forms = document.querySelectorAll('form[action*="/contact"]');
    forms.forEach(function (form) {
      if (form.dataset.bmHardened) return;
      var ft = form.querySelector('input[name="form_type"]');
      if (ft && ft.value !== 'contact') return; // newsletter (customer) : pas de case devis
      form.dataset.bmHardened = '1';
      // honeypot (piege a bots)
      var hp = document.createElement('div');
      hp.setAttribute('aria-hidden', 'true');
      hp.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;';
      hp.innerHTML = '<input type="text" name="contact[site_web]" tabindex="-1" autocomplete="off">';
      form.appendChild(hp);
      // consentement RGPD (sauf si le formulaire a deja sa propre case)
      var consent = null;
      if (!form.querySelector('input[name="contact[Consentement]"]')) {
        var submit = form.querySelector('[type="submit"], button[name="commit"], button:not([type="button"])');
        consent = document.createElement('label');
        consent.className = 'bymoove-consent';
        consent.style.cssText = 'display:flex;align-items:flex-start;gap:8px;margin:14px 0;font-size:14px;color:#2a3542;text-align:left;';
        consent.innerHTML = '<input type="checkbox" class="bymoove-consent-box" style="margin-top:2px;accent-color:#36ae9b;flex:none;"> <span>J\'accepte que mes informations soient utilisées pour traiter ma demande. <a href="/pages/politique-confidentialite" target="_blank" rel="noopener" style="text-decoration:underline;">Politique de confidentialité</a>.</span>';
        if (submit && submit.parentNode) submit.parentNode.insertBefore(consent, submit);
      }
      form.noValidate = true; // validation ByMoove (messages clairs) à la place des bulles du navigateur
      form.querySelectorAll('input[type="tel"]').forEach(function (i) { i.setAttribute('inputmode', 'tel'); });
      var consentBox = form.querySelector('input[name="contact[Consentement]"]') || form.querySelector('.bymoove-consent-box');
      if (consentBox) consentBox.dataset.bmConsent = '1';
      form.addEventListener('input', function (e) { if (e.target.dataset.bmTouched) bmCheck(e.target); });
      form.addEventListener('change', function (e) { if (e.target.dataset.bmTouched) bmCheck(e.target); });
      form.addEventListener('focusout', function (e) { var el = e.target; if (el.matches && el.matches('input,textarea,select') && (el.value || el.dataset.bmTouched)) { el.dataset.bmTouched = '1'; bmCheck(el); } });
      form.addEventListener('submit', function (e) {
        var bot = form.querySelector('[name="contact[site_web]"]');
        if (bot && bot.value) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        if (!window.BMValidate(form)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
        // consentement transmis dans un champ à part (plus dans le message)
        var box = form.querySelector('.bymoove-consent-box');
        if (box && box.checked && !form.querySelector('input[type="hidden"][name="contact[Consentement]"]')) {
          var h = document.createElement('input'); h.type = 'hidden'; h.name = 'contact[Consentement]'; h.value = 'Oui'; form.appendChild(h);
        }
        var card = form.closest('.bmda__card'); if (card) { try { sessionStorage.setItem('bmFormH', String(card.offsetHeight)); } catch (er) {} }
      }, true);
    });
  }

  /* Non-pro : achat en ligne reserve aux pros. Le bouton reste 'Ajouter au panier' (recette 15/10 : un seul bouton vers le panier,
     le choix commande/devis se fait au panier) + note sous le bouton. */
  function relabelForNonPro() {
    if (!window.BM_NONPRO) return;
    var ADD = /panier|cart|ajouter/i, SKIP = /rupture|épuis|epuis|sold|indispo|coming|pré-?comm|precomm/i;
    function ownText(el) { var t = ''; for (var n = el.firstChild; n; n = n.nextSibling) { if (n.nodeType === 3) t += n.nodeValue; } return t.trim(); }
    function setOwnText(el, val) { var done = false; for (var n = el.firstChild; n; n = n.nextSibling) { if (n.nodeType === 3 && n.nodeValue.trim()) { if (!done) { n.nodeValue = val; done = true; } else { n.nodeValue = ''; } } } if (!done) el.appendChild(document.createTextNode(val)); }
    function fix(btn) {
      var cand = [].slice.call(btn.querySelectorAll('span')); cand.push(btn);
      for (var i = 0; i < cand.length; i++) { var el = cand[i]; if (el.classList && el.classList.contains('visually-hidden')) continue; var own = ownText(el); if (own && ADD.test(own) && !SKIP.test(own) && own !== 'Ajouter au devis') { setOwnText(el, 'Ajouter au devis'); return; } }
    }
    document.querySelectorAll('form[action*="/cart/add"] [type="submit"], product-form [type="submit"], .product-form__submit').forEach(function (btn) {
      if (btn.getAttribute('name') === 'checkout') return;
      if (window.BM_RELABEL_DEVIS) { fix(btn); if (!btn.dataset.bmObs) { btn.dataset.bmObs = '1'; new MutationObserver(function () { fix(btn); }).observe(btn, { childList: true, subtree: true, characterData: true }); } }
    });
    var bb = document.querySelector('.product__block--buy_buttons');
    if (bb && !document.querySelector('.bymoove-nonpro-hint')) {
      var p = document.createElement('p'); p.className = 'bymoove-nonpro-hint';
      p.style.cssText = 'font-size:.85rem;line-height:1.45;color:#5b4a2e;background:#fff7ec;border:1px solid #f3e2c3;border-radius:10px;padding:10px 12px;margin:10px 0 0;';
      p.textContent = 'Achat en ligne réservé aux comptes pros connectés. Ajoutez vos produits au panier, puis demandez votre devis (réponse sous 24 h).';
      bb.appendChild(p);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); wireDevisOblig(); hardenContactForms(); relabelForNonPro(); });
  else { run(); wireDevisOblig(); hardenContactForms(); relabelForNonPro(); }
})();

/* ByMoove 16/10 : tous les liens externes s'ouvrent dans un nouvel onglet (demande Adrien).
   Au chargement + au clic (couvre les sections rechargees en AJAX). mailto/tel non concernes. */
(function () {
  function isExternal(a) {
    var href = a.getAttribute('href');
    if (!href || /^(#|\/(?!\/)|mailto:|tel:|javascript:)/i.test(href)) return false;
    try { return new URL(a.href, location.href).host !== location.host; } catch (e) { return false; }
  }
  function mark(a) {
    if (!isExternal(a)) return;
    a.target = '_blank';
    var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
    if (rel.indexOf('noopener') < 0) rel.push('noopener');
    a.setAttribute('rel', rel.join(' '));
  }
  function markAll(root) { (root || document).querySelectorAll('a[href]').forEach(mark); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { markAll(); });
  else markAll();
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (a) mark(a);
  }, true);
})();

/* Recette 16/10 n°28 : les « recherches suggérées » de Shopify perdent les accents (« dtente » pour « détente »).
   On retrouve le bon texte dans les titres des produits affichés, puis on remet une seule majuscule. */
(function () {
  function restore(q, titles) {
    var low = q.toLowerCase();
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i], kept = '', map = [];
      for (var j = 0; j < t.length; j++) { var c = t[j].toLowerCase(); if (c.charCodeAt(0) < 128) { kept += c; map.push(j); } }
      var k = kept.indexOf(low);
      if (k > -1) return t.slice(map[k], map[k + low.length - 1] + 1);
    }
    return q;
  }
  function fix(root) {
    var box = root.querySelector('.predictive-search-result--queries'); if (!box || box.dataset.bmFixed) return;
    var titles = [].slice.call(root.querySelectorAll('.product-card__title, .product-card h3, .predictive-search-result--collections a, .predictive-search-result--article a')).map(function (e) { return e.textContent.trim(); });
    box.querySelectorAll('a').forEach(function (a) {
      var txtEl = a.querySelector('.predictive-search-result__text, span:last-child') || a;
      var q = txtEl.textContent.replace(/\s+/g, ' ').trim(); if (!q) return;
      var s = restore(q, titles).toLowerCase();
      txtEl.textContent = s.charAt(0).toUpperCase() + s.slice(1);
      txtEl.style.textTransform = 'none';
    });
    box.dataset.bmFixed = '1';
  }
  function watch() {
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      if (ps.dataset.bmWatch) return; ps.dataset.bmWatch = '1';
      new MutationObserver(function () { fix(ps); }).observe(ps, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* Mobile 16/10 : colonnes du pied de page repliables (Contact reste ouverte) */
(function () {
  function init() {
    var cols = document.querySelectorAll('.bmf__cols > .bmf__col');
    cols.forEach(function (col, i) {
      if (i === 0 || col.dataset.bmAcc) return;
      var t = col.querySelector('.bmf__ctitle'), list = col.querySelector('.bmf__list');
      if (!t || !list) return;
      col.dataset.bmAcc = '1'; col.classList.add('bmf__col--acc');
      t.setAttribute('role', 'button'); t.setAttribute('tabindex', '0'); t.setAttribute('aria-expanded', 'false');
      var toggle = function () { var open = col.classList.toggle('is-open'); t.setAttribute('aria-expanded', open ? 'true' : 'false'); };
      t.addEventListener('click', toggle);
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
